import React from "react";
import Modal from "./Modal";
import PrimaryButton from "../components/Buttons/PrimaryButton";
import LoadingIcons from "react-loading-icons";
import { AlertTriangle } from "lucide-react";

interface Member {
  id: string;
  user_id: string | null;
  email: string;
  name?: string;
  role: string;
  status: string;
  created_at: string;
}

interface RemoveMemberModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  removingMember: Member | null;
  removeLoading: boolean;
  removeError: string | null;
  onRemoveMember: () => void;
}

const RemoveMemberModal: React.FC<RemoveMemberModalProps> = ({
  isOpen,
  setIsOpen,
  removingMember,
  removeLoading,
  removeError,
  onRemoveMember,
}) => {
  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className="sm:flex sm:items-start">
        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
          <AlertTriangle className="h-6 w-6 text-red-600" />
        </div>
        <div className="mt-3 sm:ml-4 sm:mt-0 text-left w-full">
          <h3 className="text-lg font-semibold leading-6 text-gray-900 mb-4">
            Remove member
          </h3>

          {removeError && (
            <div
              className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4"
              role="alert"
            >
              {removeError}
            </div>
          )}

          {removingMember && (
            <div className="mb-4">
              <p className="text-sm text-gray-600">
                Are you sure you want to remove{" "}
                <span className="font-medium text-gray-900">
                  {removingMember.name || removingMember.email}
                </span>{" "}
                from this organisation? This action cannot be undone.
              </p>
            </div>
          )}

          <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-2">
            <button
              type="button"
              onClick={onRemoveMember}
              disabled={removeLoading}
              className="w-full sm:w-auto inline-flex justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {removeLoading ? (
                <span className="flex items-center gap-2">
                  <LoadingIcons.TailSpin stroke="#fff" width="16" height="16" />
                  Removing...
                </span>
              ) : (
                "Remove Member"
              )}
            </button>
            <button
              type="button"
              onClick={() => setIsOpen(false)}
              disabled={removeLoading}
              className="mt-3 sm:mt-0 w-full sm:w-auto inline-flex justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default RemoveMemberModal;
